import { COUNTRY_FLAG_LANGUAGE } from '@/configs/language/config';
import { LanguageFullNameEnum, LANGUAGES } from '@/constants/leng';

export const NAVBAR_DIMENSIONS = {
  DESKTOP_HEIGHT: 47,
  MOBILE_HEIGHT: 32,
  DESKTOP_MIN_WIDTH: 120,
  MOBILE_MIN_WIDTH_AVATAR: 32,
  MOBILE_MIN_WIDTH_LANG: 50,
} as const;

export const NAVBAR_LANGUAGES_OPTIONS = [
  {
    value: LanguageFullNameEnum.ES,
    abbreviation: LANGUAGES.ES,
    id: LANGUAGES.ES,
    icon: COUNTRY_FLAG_LANGUAGE.ES,
  },
  {
    value: LanguageFullNameEnum.EN,
    abbreviation: LANGUAGES.EN,
    id: LANGUAGES.EN,
    icon: COUNTRY_FLAG_LANGUAGE.EN,
  },
] as const;

export type LanguageOption = (typeof NAVBAR_LANGUAGES_OPTIONS)[number];
export type LanguageId = LanguageOption['id'];
